import Vue from 'vue'
import VueRouter from 'vue-router'
import Account from '../views/Account.vue'
import Projekte from '../views/Projekte.vue'
import Start from '../views/Start.vue'
import Templates from '../views/Templates.vue'
import Plugins from '../views/Plugins.vue'
import Sprachen from '../views/Sprachen.vue'
import Blog from '../views/Blog.vue'
import Shop from '../views/Shop.vue'
import Technisches from '../views/Technisches.vue'
import Services from '../views/Services.vue'
import Zusammenfassung from '../views/Zusammenfassung.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      title: 'Ihr Account'
    }
  },
  {
    path: '/projekte',
    name: 'Projekte',
    component: Projekte,
    meta: {
      title: 'Ihre Projekte'
    }
  },
  {
    path: '/',
    name: 'Start',
    component: Start,
    meta: {
      title: 'Ihr Webentwickler'
    }
  },
  {
    path: '/templates',
    name: 'Templates',
    component: Templates,
    meta: {
      title: 'Templates konfigurieren'
    }
  },
  {
    path: '/sprachen',
    name: 'Sprachen',
    component: Sprachen,
    meta: {
      title: 'Sprachen festlegen'
    }
  },
  {
    path: '/plugins',
    name: 'Plug-ins',
    component: Plugins,
    meta: {
      title: 'Plug-ins hinzufügen'
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
    meta: {
      title: 'Blog-Funktionen'
    }
  },
  {
    path: '/shop',
    name: 'Online Shop',
    component: Shop,
    meta: {
      title: 'Shop-Funktionen'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: {
      title: 'Services wählen'
    }
  },
  {
    path: '/technisches',
    name: 'Technisches',
    component: Technisches,
    meta: {
      title: 'Technische Details'
    }
  },
  {
    path: '/zusammenfassung',
    name: 'Zusammenfassung',
    component: Zusammenfassung,
    meta: {
      title: 'Ihre Konfiguration'
    }
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  /*
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  */
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      let timeout = (savedPosition ? 200 : 400)
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          window.scrollTo(0, 0)
          resolve({ x: 0, y: 0 })
        }
      }, timeout)
    })
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title ? 'clickzip - ' + to.meta.title : 'clickzip'
  })
})

export default router
